import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';

interface DetailsFieldRequiredMarkerProps {
  isRequired?: boolean;
  hasError?: boolean;
}

const SR_ONLY_STYLES = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const;

const DetailsFieldRequiredMarker = ({ isRequired, hasError }: DetailsFieldRequiredMarkerProps) => {
  const { translate } = useTranslation();

  if (!isRequired && !hasError) {
    return null;
  }

  return (
    <>
      <Typography
        component="span"
        variant="body2"
        aria-hidden
        sx={{ ml: 0.25, flexShrink: 0, color: hasError ? 'error.main' : 'text.secondary' }}
      >
        *
      </Typography>
      <Box component="span" sx={SR_ONLY_STYLES}>
        {translate(hasError ? LangEnum.GLOBAL_PENDING : LangEnum.GLOBAL_REQUIRED)}
      </Box>
    </>
  );
};

export default DetailsFieldRequiredMarker;
